// import React, { useRef, useEffect, useState } from "react";

// const months = [
//   "January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December"
// ];

// const years = Array.from({ length: 50 }, (_, i) => 2000 + i); // Years from 2000 to 2049

// const ThemedCalendar = ({ 
//   value, 
//   onChange, 
//   selectedMonth, 
//   selectedYear, 
//   onSelectDate, 
//   onClose 
// }) => {
//   const calendarRef = useRef(null);

//   // Extract month & year from value if provided
//   const parsedDate = value ? new Date(value) : new Date();
//   const [month, setMonth] = useState(selectedMonth ?? parsedDate.getMonth());
//   const [year, setYear] = useState(selectedYear ?? parsedDate.getFullYear());

//   // Close calendar if clicked outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (calendarRef.current && !calendarRef.current.contains(event.target)) {
//         onClose?.();
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [onClose]);

//   // Get number of days in selected month/year
//   const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

//   // Handle date selection
//   const handleDateSelect = (day) => {
//     const formattedDate = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    
//     if (onSelectDate) {
//       onSelectDate("day", day);
//     } else if (onChange) {
//       onChange(formattedDate);
//       onClose?.();
//     }
//   };

//   return (
//     <div
//       ref={calendarRef}
//       className="absolute left-0 mt-2 w-[300px] bg-[#088F8F] text-white rounded-md shadow-lg p-4 z-10"
//     >
//       {/* Month & Year Selection */}
//       <div className="flex justify-between items-center mb-2">
//         <select
//           className="bg-transparent border-none text-white text-xl cursor-pointer"
//           value={month}
//           onChange={(e) => {
//             const newMonth = Number(e.target.value);
//             setMonth(newMonth);
//             onSelectDate?.("month", newMonth);
//           }}
//         >
//           {months.map((monthName, index) => (
//             <option key={index} value={index} className="text-black">
//               {monthName}
//             </option>
//           ))}
//         </select>
//         <select
//           className="bg-transparent border-none text-white text-sm cursor-pointer"
//           value={year}
//           onChange={(e) => {
//             const newYear = Number(e.target.value);
//             setYear(newYear);
//             onSelectDate?.("year", newYear);
//           }}
//         >
//           {years.map((yearValue) => (
//             <option key={yearValue} value={yearValue} className="text-black">
//               {yearValue}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* Days Grid */}
//       <div className="grid grid-cols-7 text-center text-xs font-light">
//         {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, index) => (
//           <div key={index} className="py-1">
//             {day}
//           </div>
//         ))}
//       </div>
//       <div className="grid grid-cols-7 text-center">
//         {Array.from({ length: getDaysInMonth(month, year) }, (_, i) => i + 1).map((day) => (
//           <div
//             key={day}
//             className="py-4 cursor-pointer hover:bg-white hover:text-[#088F8F] rounded-full"
//             onClick={() => handleDateSelect(day)}
//           >
//             {day}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ThemedCalendar;
import React, { useRef, useEffect, useState } from "react";

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const years = Array.from({ length: 50 }, (_, i) => 2000 + i); // Years from 2000 to 2049

const ThemedCalendar = ({
  value,
  onChange,
  selectedMonth,
  selectedYear,
  onSelectDate,
  onClose,
  minDate, // Add minDate prop
  disabledDate, // Add disabledDate prop
  disabled
}) => {
  const calendarRef = useRef(null);

  // Extract month & year from value if provided
  const parsedDate = value ? new Date(value) : new Date();
  const [month, setMonth] = useState(selectedMonth ?? parsedDate.getMonth());
  const [year, setYear] = useState(selectedYear ?? parsedDate.getFullYear());

  // Close calendar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  // Get number of days in selected month/year
  const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

  // Get first day of the month (0 = Sunday, 1 = Monday, etc.)
  const getFirstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

  // Check if a date is disabled
  const isDateDisabled = (day) => {
    if (disabled) return true;
    
    const currentDate = new Date(year, month, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    currentDate.setHours(0, 0, 0, 0); // Reset time to start of day
    
    // Only disable dates before today (allow today and future dates)
    if (currentDate < today) {
      return true;
    }
    
    // Check against minDate
    if (minDate && currentDate < new Date(minDate)) {
      return true;
    }
    
    // Check against disabledDate function
    if (disabledDate && disabledDate(currentDate)) {
      return true;
    }
    
    return false;
  };

  // Handle date selection
  const handleDateSelect = (day) => {
    if (isDateDisabled(day)) {
      return; // Don't allow selection of disabled dates
    }
    
    const formattedDate = `${String(month + 1).padStart(2, "0")}/${String(day).padStart(2, "0")}/${year}`;
    
    if (onSelectDate) {
      onSelectDate("day", day);
    } else if (onChange) {
      onChange(formattedDate);
      onClose?.();
    }
  };

  // Create array of dates including empty cells for proper calendar layout
  const createCalendarDays = () => {
    const daysInMonth = getDaysInMonth(month, year);
    const firstDay = getFirstDayOfMonth(month, year);
    const days = [];

    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days.push({ day: null, isEmpty: true });
    }

    // Add actual days
    for (let day = 1; day <= daysInMonth; day++) {
      days.push({ 
        day, 
        isEmpty: false, 
        isDisabled: isDateDisabled(day) 
      });
    }

    return days;
  };

  const calendarDays = createCalendarDays();

  return (
    <div
      ref={calendarRef}
      className="absolute left-0 mt-2 w-[300px] bg-[#088F8F] text-white rounded-md shadow-lg p-4 z-10"
    >
      {/* Month & Year Selection */}
      <div className="flex justify-between items-center mb-2">
        <select
          className="bg-transparent border-none text-white text-xl cursor-pointer"
          value={month}
          onChange={(e) => {
            const newMonth = Number(e.target.value);
            setMonth(newMonth);
            onSelectDate?.("month", newMonth);
          }}
          disabled={disabled}
        >
          {months.map((monthName, index) => (
            <option key={index} value={index} className="text-black text-sm">
              {monthName}
            </option>
          ))}
        </select>
        <select
          className="bg-transparent border-none text-white text-sm cursor-pointer"
          value={year}
          onChange={(e) => {
            const newYear = Number(e.target.value);
            setYear(newYear);
            onSelectDate?.("year", newYear);
          }}
          disabled={disabled}
        >
          {years.map((yearValue) => (
            <option key={yearValue} value={yearValue} className="text-black">
              {yearValue}
            </option>
          ))}
        </select>
      </div>

      {/* Days Header */}
      <div className="grid grid-cols-7 text-center text-xs font-light">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, index) => (
          <div key={index} className="py-1">
            {day}
          </div>
        ))}
      </div>

      {/* Days Grid */}
      <div className="grid grid-cols-7 text-center">
        {calendarDays.map((dayObj, index) => (
          <div
            key={index}
            className={`py-4 ${
              dayObj.isEmpty 
                ? '' 
                : dayObj.isDisabled 
                  ? 'text-gray-400 cursor-not-allowed' 
                  : 'cursor-pointer hover:bg-white hover:text-[#088F8F] rounded-full'
            }`}
            onClick={() => !dayObj.isEmpty && !dayObj.isDisabled && handleDateSelect(dayObj.day)}
          >
            {dayObj.isEmpty ? '' : dayObj.day}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThemedCalendar;